import { render } from "./Debug.vue?vue&type=template&id=75c59f8f"
import script from "./Debug.vue?vue&type=script&lang=ts"
export * from "./Debug.vue?vue&type=script&lang=ts"

import "./Debug.vue?vue&type=style&index=0&id=75c59f8f&lang=scss"
script.render = render

export default script